import AppProviders from 'providers'
import Routes from 'routes'
import Header from 'components/header'
import PopUpHealth from 'views/agegate/components/popUpHealth'
import { useLocation } from 'react-router-dom'
import { LoaderContext } from 'contexts/loader-context'
import { useAgegateConfig } from 'hooks/use-agegate'
import { useContext } from 'react'
import LoadingScreen from 'components/loading-screen'
import Footer from 'components/footer'
import FacebookSDK from 'components/facebookSDK'
import MetaPixel from 'components/meta-pixel'
import ComingSoon from './components/coming-soon'

function App() {
  const { load, head, footer } = useContext(LoaderContext)

  useAgegateConfig()
  const location = useLocation()

  return (
    <AppProviders>
      <ComingSoon>
        {FC_CLIENTID && <FacebookSDK />}
        <MetaPixel />
        {load && <LoadingScreen />}
        {head && <Header />}
        <div className={`w-full flex-1 flex justify-center sm:max-w-sm z-1 app-container`}>
          <PopUpHealth />
          <Routes />
        </div>
        {footer && location.pathname !== '/help' && <Footer />}
      </ComingSoon>
    </AppProviders>
  )
}

export default App
